import React from 'react'
import { Modal } from '../../_EOS/Modal'
import DeclareError from '../DeclareError'

interface DeclareErrorModalProps {
  isOpen: boolean
  onClose: () => void
  userId: number
  workOrderId: number
  showNotification: (message: string, success: boolean) => void
}

export const DeclareErrorModal: React.FC<DeclareErrorModalProps> = ({
  isOpen,
  onClose,
  userId,
  workOrderId,
  showNotification
}) => {
  // Traducir la nueva prop a las props que el componente hijo genérico espera
  const onErrorFinishing = () => showNotification('Error al finalizar', false)
  const onSuccessFinishing = () =>
    showNotification('Registro de errores finalizó correctamente', true)
  const onErrorGettingBefore = () =>
    showNotification('Error obteniendo errores declarados previamente', false)
  const onErrorSkuValidation = (message: string) =>
    showNotification(message, false)

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      cancelButton={{ title: 'Cancelar', action: onClose }}
    >
      <DeclareError
        userId={userId}
        asnId={workOrderId}
        closeDeclareError={onClose}
        errorFinishingDeclareErrors={onErrorFinishing}
        errorGettingBeforeDeclaredErrors={onErrorGettingBefore}
        successFinishingDeclareErrors={onSuccessFinishing}
        onErrorSkuValidation={onErrorSkuValidation}
      />
    </Modal>
  )
}
